import axios from 'axios'
import { API_ENDPOINT } from '../../config'
import store from '../../redux/stores/store'
import { AUTH_SAVE } from '../../redux/reducers/auth/action-types'


const getDefaultState = () => {
    return {
        isLoggedIn: false,
    }
}

const refreshToken = (instance) => {
    axios({
            method: 'post',
            url: API_ENDPOINT + "/api/member/refresh-login",
            headers: {
                "Authorization": store.getState().auth.refreshToken
            }
        }).then(response => handleRefreshTokenResponse(instance, response))
        .catch(error => {
            //alert(error)
        })
}

const handleRefreshTokenResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            let auth = store.getState().auth
            auth.authorizationToken = response.data.data.authorizationToken
            sessionStorage.setItem("auth", JSON.stringify(auth))
            instance.props.dispatch({
                type: AUTH_SAVE,
                payload: auth
            })
            break
        default:
            console.log(response.data.message)
    }
}

const Service = instance => {
    return {
        getDefaultState: getDefaultState,
        refreshToken: () => refreshToken(instance)
    }
}

export default Service